import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { useCustomisation } from "../../../context/CustomisationContext";
import { useTranslation } from "../../../context/TranslationContext";
import { BackToLoginButton } from "../../components/BackToLoginButton";

interface CheckEmailProps {
  sendEmail: () => void;
  loading: boolean;
  email: string;
}

export const CheckEmail: React.FC<CheckEmailProps> = ({
  sendEmail,
  loading,
  email,
}) => {
  const { customisations } = useCustomisation();
  const { translations } = useTranslation();
  const forgotPasswordTranslations =
    translations.translations["forgot-password"];
  const {
    LOGIN: {
      textColorsSettings: loginTextColors,
      buttonsSettings: loginbuttonssettings,
    },
    GPC: {
      textColorsSettings: gpcTextColors,
      buttonsSettings: gpcbuttonssettings,
    },
  } = customisations.customisations;
  const secondaryTextColor =
    loginTextColors?.loginSecondaryTextColor ??
    gpcTextColors?.gpcSecondaryTextColor;
  const linkColor =
    loginbuttonssettings?.loginLinkColor ?? gpcbuttonssettings?.gpcLinkColor;

  return (
    <>
      <Stack spacing={1} width="100%">
        <Typography
          variant="h4"
          align="center"
          color={secondaryTextColor}
          sx={{ fontWeight: 600 }}
        >
          {forgotPasswordTranslations.forgotPasswordInfo?.checkMailText}
        </Typography>
        <Typography variant="body1" align="center" color={secondaryTextColor}>
          {`${forgotPasswordTranslations.forgotPasswordInfo?.checkMailDsc} ${email}`}
        </Typography>
      </Stack>
      <Stack spacing={4} width="100%" alignItems="center">
        <Stack width="100%">
          <Stack
            direction="row"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="body2" color={secondaryTextColor}>
              {forgotPasswordTranslations.forgotPasswordInfo?.notReceive}
            </Typography>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Typography
                onClick={sendEmail}
                sx={{
                  fontWeight: 600,
                  color: linkColor,
                  cursor: "pointer",
                }}
              >
                {forgotPasswordTranslations.forgotPasswordInfo?.clickToResend}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
      <BackToLoginButton />
    </>
  );
};
